
import { motion, useTransform, type MotionValue } from "framer-motion";
import type { KeyframeBand } from "../types";
import { LAYOUT } from "../graph-layout";

const SWEEP_W = 240;

interface Props {
  progress: MotionValue<number>;
  band: KeyframeBand;
}

export function Beat2Scan({ progress, band }: Props) {
  const sweepX = useTransform(
    progress,
    [band.start, band.end],
    [-SWEEP_W, LAYOUT.viewBox.w + SWEEP_W],
  );

  const opacity = useTransform(
    progress,
    [band.start, band.start + 0.02, band.end - 0.02, band.end],
    [0, 1, 1, 0],
  );

  return (
    <motion.g style={{ opacity }} data-beat="2" aria-hidden="true">
      <defs>
        <linearGradient id="beat2-sweep" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%"   stopColor="rgba(47,107,99,0)" />
          <stop offset="50%"  stopColor="rgba(47,107,99,0.30)" />
          <stop offset="100%" stopColor="rgba(47,107,99,0)" />
        </linearGradient>
      </defs>
      <motion.rect
        style={{ x: sweepX }}
        y={0}
        width={SWEEP_W}
        height={LAYOUT.viewBox.h}
        fill="url(#beat2-sweep)"
      />
    </motion.g>
  );
}
